import { render, staticRenderFns } from "./ConfirmCopyDiaryModal.html?vue&type=template&id=23ffa11e&scoped=true&external"
import script from "./ConfirmCopyDiaryModal.js?vue&type=script&lang=js&external"
export * from "./ConfirmCopyDiaryModal.js?vue&type=script&lang=js&external"
import style0 from "./ConfirmCopyDiaryModal.scss?vue&type=style&index=0&id=23ffa11e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ffa11e",
  null
  
)

export default component.exports